import React from "react";
import { Button, Flex, Tooltip } from "antd";
import { Crown1, Trash } from "iconsax-react";
import "./PaymentMethodItem.scss";

interface Props {
  cardName?: string;
  cardNumber?: string;
  cardLogo?: string;
  isDefault?: boolean;
  editDisabled?: boolean;
  deleteDisabled?: boolean;
  onRemove?: () => void;
  onSetDefault?: () => void;
}

const PaymentMethodItem: React.FC<Props> = (props) => {
  const {
    cardName,
    cardNumber,
    cardLogo,
    isDefault = false,
    editDisabled = false,
    deleteDisabled = false,
    onRemove,
    onSetDefault,
  } = props;

  const handleRemove = () => {
    if (onRemove && !deleteDisabled) {
      onRemove();
    }
  };

  const handleSetDefault = () => {
    if (onSetDefault && !editDisabled) {
      onSetDefault();
    }
  };

  return (
    <div className="payment-method-item">
      <div className="controls">
        <Tooltip title="Remove">
          <Button
            icon={<Trash size={18} variant="Bold" />}
            className="rs-button danger"
            disabled={deleteDisabled}
            onClick={handleRemove}
            shape="circle"
          />
        </Tooltip>
        {!isDefault && (
          <Tooltip title="Set as default">
            <Button
              icon={<Crown1 size={18} variant="Bold" />}
              type="primary"
              className="rs-button button-primary"
              disabled={editDisabled}
              onClick={handleSetDefault}
              shape="circle"
            />
          </Tooltip>
        )}
      </div>
      <div className="info">
        <div className="title">{cardName}</div>
        <div className="number">{cardNumber}</div>
      </div>
      <div className="foot">
        <img src={cardLogo} alt="" />
        {isDefault && (
          <Flex gap={8} align="center" className="default">
            <Crown1 variant="Bulk" size={24} />
            <span>Default</span>
          </Flex>
        )}
      </div>
    </div>
  );
};

export default PaymentMethodItem;
